<template>
  <div>
    <Editor id="sakra-meddelanden-editor" :onInput="() => emit('update:modelValue', tinymce.activeEditor?.getContent())
      " :onSelectionChange="() => emit('update:modelValue', tinymce.activeEditor?.getContent())
        " :init="{
          license_key: 'gpl',
          plugins: 'lists link',
          toolbar:
            'styles | bold italic underline strikethrough | bullist numlist | link',
          paste_preprocess: (_: any, args: any) => {
            args.content = sanitizePaste(args.content);
          },
          promotion: false,
          statusbar: true,
          branding: false,
          elementpath: false,
          menubar: false,
          language: 'sv_SE',
          language_url:
            'src/components/arende-management/components/RichTextInput/sv_SE.js',
          placeholder,
          min_height: 220,
          height: 220,
          resize: true,
          highlight_on_focus: false,
          default_font_stack: [
            'Work Sans',
            'Helvetica Neue',
            'Helvetica',
            'Arial',
          ],
          content_style: contentStyle,
          formats: {
            standardtext: { block: 'div' },
            heading1: { block: 'h2' },
            heading2: { block: 'h3' },
          },
          style_formats: [
            {
              title: 'Standardtext',
              format: 'standardtext',
              class: 'type-body-md',
            },
            { title: 'Rubrik 1', format: 'heading1' },
            { title: 'Rubrik 2', format: 'heading2' },
          ],
          link_default_target: '_blank',
          browser_spellcheck: true,
          contextmenu: false,
          init_instance_callback: (editor: any) => {
            emit('ready', editor);
          }
        }" />
  </div>
</template>

<script setup lang="ts">
import Editor from "@tinymce/tinymce-vue";
import DOMPurify from "dompurify";
import tinymce from "tinymce/tinymce";
import "tinymce/icons/default/icons.min.js";
import "tinymce/models/dom/model.min.js";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/skins/content/default/content.js";
import contentCss from "tinymce/skins/content/default/content.min.css?inline";
import contentUiCss from "tinymce/skins/ui/oxide/content.inline.min.css?inline";
import "tinymce/skins/ui/oxide/content.js";
import "tinymce/skins/ui/oxide/skin.js";
import "tinymce/themes/silver/theme.min.js";
import { watch } from "vue";

import "./sv_SE.js";

const contentStyle =
  contentUiCss.toString() +
  "\n" +
  contentCss.toString() +
  "\n" +
  "p { margin:0 }";

type RichTextInputProps = {
  modelValue?: string | undefined;
  placeholder?: string | undefined;
};

const props = defineProps<RichTextInputProps>();

const emit = defineEmits(["update:modelValue", "ready"]);

watch(
  () => props.modelValue,
  (newValue) => {
    const editor = tinymce.activeEditor;
    if (editor && editor.getContent() !== newValue) {
      editor.setContent(newValue || "");
    }
  },
);

const sanitizePaste = (content: string) => {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      "div",
      "p",
      "strong",
      "em",
      "span",
      "s",
      "ul",
      "ol",
      "li",
      "a",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "pre",
      "u",
      "br",
      "section",
    ],
  });
};
</script>

<style scoped>
:deep(.tox-tinymce) {
  border: solid 2px;
}

:deep(.tox-statusbar) {
  flex-direction: row-reverse;
}
</style>
